var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-clipped"},[(_vm.$attrs.image !== undefined)?_c('img',_vm._g(_vm._b({staticClass:"d-block",style:(_vm.imgStyle),attrs:{"src":_vm.src,"alt":""}},'img',_vm.$attrs,false),_vm.$listeners)):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }